import React from 'react';
import PortfolioTitle from '../../Utilities/PortfolioTitle'

// material
import Grid from '@material-ui/core/Grid'

// Images
import NfcImage from '../../../assets/portfolio/IoT/IconIot.png'

export default class AppDevelopment extends React.Component{
 render(){
  return(
    <section>
      <div className="container PortfolioItem" style={{marginBottom: 80, }}>
        <Grid container alignItems="flex-center">
          <Grid item className="AppDevelopmentImage">
          <img style={{maxHeight: 80}} src={NfcImage} alt=""/>
          </Grid>
          <Grid item>
          <PortfolioTitle colorTitle="white" colorSubtitle="white" title="NFC & IoT" subtitle="Experts in IoT solutions, enhaced with NFC"/>
          </Grid>
        </Grid>
      </div>
    </section>
  );
 }
}


// WEBPACK FOOTER //
// ./src/Components/Portfolio/NfcAndIot/NfcAndIot.js